import { render, staticRenderFns } from "./KmnVerificationForm.vue?vue&type=template&id=10044c5a&scoped=true"
import script from "./KmnVerificationForm.vue?vue&type=script&lang=js"
export * from "./KmnVerificationForm.vue?vue&type=script&lang=js"
import style0 from "./KmnVerificationForm.vue?vue&type=style&index=0&id=10044c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10044c5a",
  null
  
)

export default component.exports